// VotosComiteCard (ADR-0014) — tabela consolidada dos votos do comitê (humanos +
// parecer de apoio da IA-Analista), revelada quando o quórum fecha (voto cego).
// Componente puro (NÃO faz network). Substitui o antigo SinteseJuizCard — a
// "Sugestão IA-Juiz" saiu com a persona (a decisão é humana).

import { useTranslation } from 'react-i18next';
import { Badge, Table, Thead, Tbody, Tr, Th, Td, type BadgeTone } from '@aions/ui-primitives';

export interface HumanVerdictRow {
  memberId: string;
  memberLabel: string;
  voto: 'procedente' | 'improcedente' | 'improcedente_insuficiencia';
  justificativaTruncada: string;
}

type Voto = 'procedente' | 'improcedente' | 'improcedente_insuficiencia';

/** Tom visual do Badge por voto (sem semântica jurídica). */
function votoTone(voto: Voto): BadgeTone {
  return voto === 'procedente' ? 'success' : voto === 'improcedente' ? 'coral' : 'amber';
}

export function VotosComiteCard({
  humanRows,
  analistaParecer,
  analistaVoto,
}: {
  humanRows: HumanVerdictRow[];
  analistaParecer: string | null;
  analistaVoto: Voto | null;
}): JSX.Element {
  const { t } = useTranslation();

  return (
    <div className="review-section" style={{ marginTop: 8 }}>
      <div className="sintese-head">
        <div>
          <div className="sintese-head__title">{t('votos_comite.title')}</div>
          <p className="sintese-head__sub">{t('votos_comite.subtitle')}</p>
        </div>
      </div>

      {humanRows.length > 0 && (
        <div style={{ marginBottom: 12 }}>
          <Table aria-label={t('votos_comite.tabela_aria')}>
            <Thead>
              <Tr>
                <Th>{t('votos_comite.col_membro')}</Th>
                <Th>{t('votos_comite.col_voto')}</Th>
                <Th>{t('votos_comite.col_justificativa')}</Th>
              </Tr>
            </Thead>
            <Tbody>
              {humanRows.map((row) => (
                <Tr key={row.memberId}>
                  <Td mono>{row.memberLabel}</Td>
                  <Td>
                    <Badge tone={votoTone(row.voto)}>
                      {t(`parecer.votos.${row.voto}`, { defaultValue: row.voto })}
                    </Badge>
                  </Td>
                  <Td style={{ fontStyle: 'italic', color: 'var(--text-secondary)' }}>
                    {row.justificativaTruncada}
                  </Td>
                </Tr>
              ))}
              {analistaParecer && analistaVoto && (
                <Tr>
                  <Td style={{ fontWeight: 'var(--fw-bold)' }}>
                    {t('votos_comite.linha_analista')}
                  </Td>
                  <Td>
                    <Badge tone={votoTone(analistaVoto)}>
                      {t(`parecer.votos.${analistaVoto}`, { defaultValue: analistaVoto })}
                    </Badge>
                  </Td>
                  <Td style={{ fontStyle: 'italic', color: 'var(--text-secondary)' }}>
                    {analistaParecer.length > 120
                      ? `${analistaParecer.slice(0, 120)}…`
                      : analistaParecer}
                  </Td>
                </Tr>
              )}
            </Tbody>
          </Table>
        </div>
      )}
    </div>
  );
}
